import type { StateCreator } from 'zustand'

import type { AllSlices } from '../types'
import type { CasinoSlice } from '../types/casino'

export const createCasinoSlice: StateCreator<
  AllSlices,
  [],
  [],
  CasinoSlice
> = set => ({
  allGames: {},
  loadedPage: {},
  setCategoryGames: (categoryKey, categoyGames, fresh, page) => {
    set(state => ({
      casino: {
        ...state.casino,
        allGames: {
          ...state.casino.allGames,
          [categoryKey]: fresh
            ? categoyGames
            : state.casino.allGames?.[categoryKey]
            ? [...state.casino.allGames[categoryKey], ...categoyGames]
            : categoyGames,
        },
        loadedPage: {
          ...state.casino.loadedPage,
          [categoryKey]: page,
        },
      },
    }))
  },
  clearCategoryGames: categoryKey => {
    set(state => {
      // The page counter goes with the games: a cleared category starts at
      // page 1 again, not wherever the previous load had reached.
      const loadedPage = { ...state.casino.loadedPage }
      delete loadedPage[categoryKey]
      return {
        casino: {
          ...state.casino,
          allGames: {
            ...state.casino.allGames,
            [categoryKey]: [],
          },
          loadedPage,
        },
      }
    })
  },
  categories: [],
  providers: null,
  setCategories: (categories) => {
    set(state => ({
        casino: { ...state.casino, categories },
      }))
  },
  // Update a single category's count in place (e.g. refreshing the recent tab's
  // badge from its live play-history response without replacing the whole list).
  setCategoryCount: (id, count) => {
    set(state => ({
      casino: {
        ...state.casino,
        categories: state.casino.categories.map(c =>
          c.id === id ? { ...c, count } : c,
        ),
      },
    }))
  },
  setProviders: (providers) => {
    set(state => ({
      casino: { ...state.casino, providers },
    }))
  },
  // Default to loading so the games grid renders its skeleton tiles (which
  // reserve the grid's height) on the very first paint. Starting at `false`
  // left the grid empty until the games fetch fired, then expanding it once
  // games arrived — a large layout shift on a fast/cold load. The first fetch
  // always resets this to `false` in its `finally`. Favorites use a separate
  // loading flag, so an empty favorites list is unaffected.
  loadMoreLoading: true,
  setLoadMoreLoading: loadMoreLoading => {
    set(state => ({
      casino: { ...state.casino, loadMoreLoading },
    }))
  },
  gameUrlParams: null,
  setGameUrlParams: gameUrlParams => {
    set(state => ({
      casino: { ...state.casino, gameUrlParams },
    }))
  },
})
